(() => {
  function initialize(root) {
    if (root.dataset.blogReady) return;
    root.dataset.blogReady = 'true';
    const articles = [...root.querySelectorAll('[data-category]')];
    const buttons = [...root.querySelectorAll('[data-filter]')];
    const count = root.querySelector('[data-blog-count]');
    const empty = root.querySelector('[data-blog-empty]');
    function filter(category) {
      let shown = 0;
      let published = 0;
      articles.forEach(article => {
        article.hidden = category !== 'all' && article.dataset.category !== category;
        if (!article.hidden) { shown++; if (article.dataset.published === 'true') published++; }
      });
      count.textContent = published === shown ? `${shown} ${shown === 1 ? root.dataset.countOne : root.dataset.countOther}` : `${published} ${root.dataset.countPublished} · ${shown - published} ${root.dataset.countUpcoming}`;
      empty.hidden = shown !== 0;
      buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.filter === category)));
    }
    buttons.forEach(button => button.addEventListener('click', () => filter(button.dataset.filter)));
    root.querySelector('[data-blog-filters]').hidden = false;
    filter('all');
    const form = root.querySelector('.cb-news-form');
    if (form && (form.querySelector('[role="alert"]') || form.querySelector('[role="status"]'))) root.querySelector('details').open = true;
  }
  function initializeAll(scope) { scope.querySelectorAll('[data-canalla-blog]').forEach(initialize); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initializeAll(document));
  else initializeAll(document);
  document.addEventListener('shopify:section:load', event => initializeAll(event.target));
})();
